//@flow
const appVerStateName = 'appVer'
const localStore = localStorage.getItem(appVerStateName)

export const appVerInitialState: any = localStore?JSON.parse(localStore): {
    [appVerStateName]: {
        error: '',
        loading: false,
        appUpdate: false,
        appVersion: '',
        appUpdateTitle: '',
        appUpdateNotes: [],
        dismissedUntil: null,
        lastChecked: null,
	}
}

type State = {
    +appVer: {
        +error: string,
        +loading: boolean,
        +appUpdate: boolean,
        +appVersion: string,
        +appUpdateTitle: string,
        +appUpdateNotes: Array<any>,
        +dismissedUntil: ?number,
        +lastChecked: ?number,
    }
}

type Action = {
    error: string,
    appUpdate: boolean,
    appVersion: string,
    appUpdateTitle: string,
    appUpdateNotes: Array<any>,
    dismissedUntil?: number
}

export const TypeAppVerError = 'appVerError'
export const TypeAppVerFetch = 'appVerFetch'
export const TypeAppVerReceived = 'appVerReceived'
export const TypeAppVerDismissed = 'appVerDismissed'
export const TypeAppVerCheckStarted = 'appVerCheckStarted'

export const appVerActions: any = {
    [TypeAppVerError]: (state:State, action:Action) => {
        const appVerState = {
            appVer: {
                ...state.appVer,
                error: action.error
            }
        }
        localStorage.setItem(appVerStateName,JSON.stringify(appVerState))
        return appVerState
    },
    [TypeAppVerFetch]: (state:State) => {
        const appVerState = {
            appVer: {
                ...state.appVer,
                loading: true,
                error: ''
            }
        }
        localStorage.setItem(appVerStateName,JSON.stringify(appVerState))
        return appVerState
    },
    [TypeAppVerReceived]: (state:State,action:Action) => {
        const appVerState = {
            appVer: {
                ...state.appVer,
                loading: false,
                error: '',
                appUpdate: action.appUpdate,
                appVersion: action.appVersion,
                appUpdateTitle: action.appUpdateTitle,
                appUpdateNotes: action.appUpdateNotes,
                lastChecked: Date.now(),
            }
        }
        localStorage.setItem(appVerStateName,JSON.stringify(appVerState))
        return appVerState
    },
    [TypeAppVerDismissed]: (state:State, action:Action) => {
        const appVerState = {
            appVer: {
                ...state.appVer,
                dismissedUntil: action.dismissedUntil
            }
        }
        localStorage.setItem(appVerStateName,JSON.stringify(appVerState))
        return appVerState
    },
    [TypeAppVerCheckStarted]: (state:State) => {
        const appVerState = {
            appVer: {
                ...state.appVer,
                lastChecked: Date.now()
            }
        }
        // No need to persist this to localStorage
        return appVerState
    }
}